import React from "react"
import { Card, CardContent, Skeleton, Divider, Grid } from "@mui/material"

const MySimulatesSkeleton = () => {
    const simulatesItem = []

    // eslint-disable-next-line
    for (let index = 0; index <= 2; index++) {
        simulatesItem.push(
            <Grid key={index} item xs={12} sm={6} md={4}>
                <Card>
                    <CardContent>
                        <Grid container justifyContent="center" alignItems="center" spacing={2}>
                            <Grid item>
                                <Skeleton
                                    variant="circle"
                                    width={90}
                                    height={90}
                                    animation="wave"
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Skeleton
                                    variant="rect"
                                    width="60%"
                                    height={18}
                                    animation="wave"
                                    sx={{
                                        margin: "0 auto"
                                    }}
                                />

                                <Divider sx={{width: '0px', marginTop: '10px'}} />

                                <Skeleton
                                    variant="rect"
                                    width="40%"
                                    height={14}
                                    animation="wave"
                                    sx={{
                                        margin: "0 auto"
                                    }}
                                />
                            </Grid>

                            <Divider sx={{width: '0px', marginTop: '10px'}} />

                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Skeleton
                                            variant="circle"
                                            width={36}
                                            height={36}
                                            animation="wave"
                                            style={{
                                                margin: "0 auto"
                                            }}
                                        />

                                        <Divider sx={{width: '0px', marginTop: '10px'}}/>

                                        <Skeleton
                                            variant="rect"
                                            width="80%"
                                            height={12}
                                            animation="wave"
                                            style={{
                                                margin: "0 auto"
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <Skeleton
                                            variant="circle"
                                            width={36}
                                            height={36}
                                            animation="wave"
                                            style={{
                                                margin: "0 auto"
                                            }}
                                        />

                                        <Divider sx={{width: '0px', marginTop: '10px'}}/>

                                        <Skeleton
                                            variant="rect"
                                            width="80%"
                                            height={12}
                                            animation="wave"
                                            style={{
                                                margin: "0 auto"
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <Skeleton
                                            variant="circle"
                                            width={36}
                                            height={36}
                                            animation="wave"
                                            style={{
                                                margin: "0 auto"
                                            }}
                                        />

                                        <Divider sx={{width: '0px', marginTop: '10px'}}/>

                                        <Skeleton
                                            variant="rect"
                                            width="80%"
                                            height={12}
                                            animation="wave"
                                            style={{
                                                margin: "0 auto"
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Divider size={1} orientation="horizontal" />

                            <Grid item xs={12}>
                                <Skeleton
                                    variant="rect"
                                    width="50%"
                                    height={22}
                                    animation="wave"
                                    style={{
                                        margin: "0 auto"
                                    }}
                                />

                                <Divider sx={{width: '0px', marginTop: '10px'}}/>

                                <Grid
                                    container
                                    alignContent="center"
                                    justifyContent="space-between"

                                >
                                    <Grid item xs={6}>
                                        <Skeleton
                                            variant="rect"
                                            width="50%"
                                            height={22}
                                            animation="wave"
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={6}
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end"
                                        }}
                                    >
                                        <Skeleton
                                            variant="rect"
                                            width="50%"
                                            height={22}
                                            animation="wave"
                                        />
                                    </Grid>
                                </Grid>

                                <Divider sx={{width: '0px', marginTop: '10px'}}/>

                                <Divider sx={{width: '100%'}}/>

                                <Divider sx={{width: '0px', marginTop: '10px'}}/>

                                <Grid
                                    container
                                    alignContent="center"
                                    justifyContent="space-between"
                                >
                                    <Grid item xs={6}>
                                        <Skeleton
                                            variant="rect"
                                            width="50%"
                                            height={22}
                                            animation="wave"
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={6}
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end"
                                        }}
                                    >
                                        <Skeleton
                                            variant="rect"
                                            width="50%"
                                            height={22}
                                            animation="wave"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Divider sx={{width: '0px', marginTop: '10px'}}/>

                            <Grid item xs={12}>
                                <Skeleton
                                    variant="rect"
                                    width="100%"
                                    height={30}
                                    animation="wave"
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        )
    }
    return (
        <Grid container spacing={2}>
            {simulatesItem}
        </Grid>
    )
}

export default MySimulatesSkeleton
